import { chainConfigs, type SupportedNetworkIds } from '@/config';

export function chainDisplayName(chainId: number): string {
  const config = chainConfigs[chainId as SupportedNetworkIds] as
    | { displayName: string }
    | undefined;
  return config?.displayName ?? `Chain ${chainId}`;
}
